import { Navigate, useLocation } from 'react-router-dom';
import { get } from '../../components/Api/Api';
import { useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import { getProductLinkFromProduct } from '../../utils/productHelper';

export default function ProductRedirectionMiddleware() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [pathToNavigate, setPathToNavigate] = useState(null);

  const productId =
    location.pathname.match(
      /^\/catalog\/product\/view(?:\/.*)?\/id\/(.[^\/]+)/,
    )?.[1] || null;

  const subjectTypesByProduct = {
    'App\\Models\\Vehicle': 'vehicle',
    'App\\Models\\Rim': 'rim',
    'App\\Models\\Tyre': 'tyre',
    'App\\Models\\Part': 'part',
  };

  if (loading) {
    if (productId) {
      get(`/items/${productId}`)
        .then((product) => {
          const subjectType = subjectTypesByProduct[product.productable_type];
          product.subjectType = subjectType;
          if (subjectType) {
            setPathToNavigate(getProductLinkFromProduct(product));
          } else {
            setPathToNavigate(`/produits/${productId}`);
          }
        })
        .catch((e) => {
          setPathToNavigate(`/produits/${productId}`);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setPathToNavigate(null);
      setLoading(false);
    }
  }

  // useEffect(() => {
  //   console.log(pathToNavigate);
  // }, [pathToNavigate]);

  return loading ? (
    <Loader />
  ) : pathToNavigate ? (
    <Navigate to={{ pathname: pathToNavigate }} replace />
  ) : (
    <Navigate to={{ pathname: '/catalogue' }} replace />
  );
}
